<template>
  <div style="background-color: #F8F9FB;" v-title data-title="杰宜斯云机构版">
    <hhead></hhead>
    <crm-nav :gsName="res"></crm-nav>
    <!-- 首页内容 -->
    <div class="index_box">
      <div class="top_box">
        <!-- 左边头部 -->
        <div class="left">
          <!-- 标题 -->
          <div class="title_box">
            <h3 @click="pushMechanism">
             {{ res.name }}</router-link>
            </h3>

            <span class="rz_y" v-if="res.checkState == 1 ? true : false"
              >已认证</span
            >
            <span
              class="rz_y"
              style="color: #5CD48C;border-color: #5CD48C;background: #F5FFFE;"
              v-if="res.checkState == 0 ? true : false"
              >审核中</span
            >

            <span
              class="rz_y"
              style="color: #FF4239;border-color: #FF4239;background-color: #FFF7F5"
              v-if="res.checkState == 2 ? true : false"
              >审核失败</span
            >
            <span
              v-if="res.checkState == 2 ? true : false"
              style="color: #FF4239;border:none;
                 margin-left: 0;
                 background-color: #fff;font-size: 12px;
                 cursor: pointer;
                 "
              >失败原因：{{ res.errorInfos | each }}&nbsp;&nbsp;&nbsp;
              <i @click="edit" style="color: #5b85ff;" class="decoration1"
                >修改资料</i
              >
            </span>
          </div>
<!-- 
          <div class="msg__box">
            <span>成立时间：{{ res.createDate | renderTime }}</span>
            <span>注册资本：{{ res.initMoney }}</span>
            <span>社会信用代码：{{ res.code | code }}</span>
          </div> -->

          <p class="Range">投资范围</p>

          <div>
            <div class="bgc">
              {{ res.bizArea }}
            </div>
          </div>

          <div class="hr"></div>

          <ul class="list">
            <li>
              <p>合作方</p>
              <div>{{ res.investorNum }}</div>
            </li>
            <li>
              <p>合作方账户</p>
              <div>{{ res.accNum }}</div>
            </li>
            <li>
              <p>
                累计收益
              </p>
              <div
                :style="{ color: res.profitRate > 0 ? '#FA5D22' : '#3ABA94' }"
              >
                {{ res.profitRate | num }}
              </div>
            </li>
            <li>
              <p>近30天到期账户</p>
              <div>{{ res.accExpireNum }}</div>
            </li>
            <li>
              <p>近30天到期合作</p>
              <div>{{ res.contractExpireNum }}</div>
            </li>
            <li>
              <p>净值低于0.8</p>
              <div style="color: #3ABA94;">
                {{ res.netNum || 0 }}
              </div>
            </li>
          </ul>
        </div>
        <!-- 右边头部 -->
        <div class="right">
          <div class="msg">
            <span class="title_l">最新消息</span>
            <span @click="pushNews" class="see"
              >查看更多<i class="el-icon-arrow-right"></i>
            </span>
          </div>
          <div class="content">
            <p
              v-if="news.length > 0"
              @click="pushNews"
              style="overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;"
              v-for="(item, index) in news"
              :key="index"
            >
              {{ item.content }}
              <span>{{ item.msgTime }}</span>
            </p>
            <div
              v-if="news.length == 0"
              style="text-align: center;margin-top:50px;margin-bottom: 20px;"
            >
              <i
                style="font-size: 80px;color: #e0e6f2; "
                class="iconfont icon-kong"
              ></i>
              <li
                style="color: #d8dde9;border: none;font-size: 18px;list-style: none;margin-top: 20px;"
              >
                暂无消息
              </li>
            </div>
          </div>
        </div>
      </div>
      <!-- 底部 -->
      <div class="bottom_box">
        <div class="Ranking">
          <div class="top">
            <div class="title">收益排行</div>
            <div class="tab">
              <span
                :style="{
                  color: n_active == '1' ? '#fff' : '#5B85FF',
                  background: n_active == '1' ? '#5B85FF' : '#fff',
                }"
                @click="month"
                >本月</span
              >
              <span
                :style="{
                  color: n_active == '2' ? '#fff' : '#5B85FF',
                  background: n_active == '2' ? '#5B85FF' : '#fff',
                }"
                @click="year"
                >本年</span
              >
            </div>
          </div>

          <!-- 本月排行 -->
          <div v-show="n_active == '1'">
            <div
              class="weekList"
              @click="pushDetail(item.id, item.serverId)"
              v-for="(item, index) in RankingList.thisMonthProfit"
              :key="index"
            >
              <div class="left" style="display: flex;flex: 1;">
                <div class="no">
                  <img
                    :src="
                      require('../../assets/images/crm/no' +
                        (index + 1) +
                        '.png')
                    "
                    alt=""
                  />
                </div>
                <div style="text-align: center;">
                  <p
                    style="width: 90px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;font-size:14px;"
                  >
                    {{ item.userName }}
                  </p>
                  <p
                    style="width: 90px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;font-size: 12px;color: #868e99;"
                  >
                    {{ item.userCode }}
                  </p>
                </div>
              </div>
              <div style="flex: 0.5;text-align: center;font-size: 14px;">
                {{ item.simpleName }}
              </div>
              <div style="flex: 1;text-align: right;">
                <p style="white-space: nowrap;">
                  累计收益：<span
                    :style="{
                      color: item.thisMonthProfit >= 0 ? '#FA5D22' : '#3ABA94',
                      fontSize: '20px',
                    }"
                  >
                    {{ item.thisMonthProfit | num }}</span
                  >
                  <i
                    style="color: #FA5D22;"
                    class="el-icon-top"
                    v-if="item.profitRateAdd > 0"
                  ></i
                  ><i
                    v-if="item.profitRateAdd < 0"
                    style="color:#3ABA94"
                    class="el-icon-bottom"
                  ></i>
                </p>

                <span
                  :style="{
                    color: item.profitRateAdd >= 0 ? '#FA5D22' : '#3ABA94',
                    fontSize: '12px',
                  }"
                  >{{ item.profitRateAdd | num }}</span
                >
              </div>
            </div>
          </div>

          <!-- 本年排行 -->
          <div v-show="n_active == '2'">
            <div
              class="weekList"
              @click="pushDetail(item.id, item.serverId)"
              v-for="(item, index) in RankingList.thisYearlyProfit"
              :key="index"
            >
              <div class="left" style="display: flex;flex: 1;">
                <div class="no">
                  <img
                    :src="
                      require('../../assets/images/crm/no' +
                        (index + 1) +
                        '.png')
                    "
                    alt=""
                  />
                </div>
                <div style="text-align: center;">
                  <p
                    style="width: 90px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;font-size: 14px;"
                  >
                    {{ item.userName }}
                  </p>
                  <p
                    style="width: 90px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;font-size: 12px;color:#868e99 ;"
                  >
                    {{ item.userCode }}
                  </p>
                </div>
              </div>
              <div style="flex: 0.5;text-align: center;font-size: 14px;">
                {{ item.simpleName }}
              </div>
              <div style="flex: 1;text-align: right;">
                <p style="white-space: nowrap;">
                  累计收益：<span
                    :style="{
                      color: item.thisYearProfit >= 0 ? '#FA5D22' : '#3ABA94',
                      fontSize: '20px',
                    }"
                  >
                    {{ item.thisYearProfit | num }}</span
                  >
                  <i
                    style="color: #FA5D22;"
                    class="el-icon-top"
                    v-if="item.profitRateAdd > 0"
                  ></i
                  ><i
                    v-if="item.profitRateAdd < 0"
                    style="color:#3ABA94"
                    class="el-icon-bottom"
                  ></i>
                </p>

                <span
                  :style="{
                    color: item.profitRateAdd >= 0 ? '#FA5D22' : '#3ABA94',
                    fontSize: '12px',
                  }"
                  >{{ item.profitRateAdd | num }}</span
                >
              </div>
            </div>
          </div>
          <div @click="seeDate" class="more">
            查看更多<i class="el-icon-arrow-right"></i>
          </div>
        </div>
        <div class="Ranking">
          <div class="jz_top">
            <span
              :style="{
                color: active == '1' ? '#5B85FF' : '#0A101E',
                borderBottom: active == '1' ? '2px solid #5B85FF' : 'none',
              }"
              @click="jz"
              >净值排行</span
            >
            <span
              :style="{
                color: active == '2' ? '#5B85FF' : '#0A101E',
                borderBottom: active == '2' ? '2px solid #5B85FF' : 'none',
              }"
              @click="hc"
              >回撤排行</span
            >
          </div>
          <!-- 净值排行 -->
          <div v-show="active == '1'">
            <div
              class="weekList"
              @click="pushDetail(item.id, item.serverId)"
              v-for="(item, index) in RankingList.sumNet"
              :key="index"
            >
              <div class="left" style="display: flex;flex: 1;">
                <div class="no">
                  <img
                    :src="
                      require('../../assets/images/crm/no' +
                        (index + 1) +
                        '.png')
                    "
                    alt=""
                  />
                </div>
                <div>
                  <p
                    style="text-align: center;width: 90px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;font-size: 14px;"
                  >
                    {{ item.userName }}
                  </p>
                  <p
                    style="text-align: center;width: 90px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;font-size: 12px;color:#868e99 ;"
                  >
                    {{ item.userCode }}
                  </p>
                </div>
              </div>
              <div style="flex: 0.51;text-align: center;font-size: 14px;">
                {{ item.simpleName }}
              </div>
              <div style="flex: 1;">
                <p style="text-align: center;">
                  净值：<span
                    :style="{ color: item.sumNet >= 1 ? '#FA5D22' : '#3ABA94' }"
                    >{{ item.sumNet | num2 }}</span
                  >
                </p>
              </div>
            </div>
          </div>
          <!-- 回撤排行 -->
          <div v-show="active == '2'">
            <div
              class="weekList"
              @click="pushDetail(item.id, item.serverId)"
              v-for="(item, index) in RankingList.maxLoss"
              :key="index"
            >
              <div class="left" style="display: flex;flex: 1;">
                <div class="no">
                  <img
                    :src="
                      require('../../assets/images/crm/no' +
                        (index + 1) +
                        '.png')
                    "
                    alt=""
                  />
                </div>
                <div>
                  <p
                    style="text-align:center;width: 90px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;font-size: 14px;"
                  >
                    {{ item.userName }}
                  </p>
                  <p
                    style="text-align:center;width: 90px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;font-size: 12px;color:#868e99 ;"
                  >
                    {{ item.userCode }}
                  </p>
                </div>
              </div>
              <div style="flex: 0.5;text-align:center;font-size: 14px;">
                {{ item.simpleName }}
              </div>
              <div style="flex: 1;">
                <p style="text-align: center;">
                  最近回撤：<span
                    :style="{
                      color: item.maxLoss >= 0 ? '#FA5D22' : '#3ABA94',
                    }"
                    >{{ item.lastLoss | num }}</span
                  >
                </p>
              </div>
            </div>
          </div>
          <div @click="seeNetWorth" class="more">
            查看更多<i class="el-icon-arrow-right"></i>
          </div>
        </div>
        <div class="Ranking" style="margin-right: 0;">
          <div class="jz_top">
            <!-- <span
              :style="{
                color: active1 == '1' ? '#5B85FF' : '#0A101E',
                borderBottom: active1 == '1' ? '2px solid #5B85FF' : 'none',
              }"
              @click="cl"
              >最优策略</span
            > -->
            <span
              :style="{
                color: active1 == '2' ? '#5B85FF' : '#0A101E',
                borderLeft: '2px solid #5b85ff',
                paddingLeft: '10px',
                height: '14px',
                lineHeight: '17px',
                marginTop: '5px',
                cursor: 'default',
              }"
              @click="jg"
              >最优合作方</span
            >
          </div>

          <!-- 最优策略 -->
          <!-- <div v-show="active1 == '1'">
            <div
              class="weekList"
              v-for="(item, index) in RankingList.strategy"
              :key="index"
            >
              <div class="left" style="display: flex;flex: 1;">
                <div class="no">
                  <img
                    :src="
                      require('../../assets/images/crm/no' +
                        (index + 1) +
                        '.png')
                    "
                    alt=""
                  />
                </div>
                <div style="text-align: center;">
                  <p
                    style="width: 90px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
                  >
                    {{ item.strategyName }}
                  </p>
                </div>
              </div>
              <div style="flex: 0.5;font-size: 14px;text-align: center;">
                账户数量
                <p>{{ item.invNum }}</p>
              </div>

              <div style="flex:1;text-align: right;">
                <p style="white-space: nowrap;">
                  累计收益：
                  <span
                    :style="{
                      color: item.profitRate >= 0 ? '#FA5D22' : '#3ABA94',
                      fontSize: '20px',
                    }"
                  >
                    {{ item.profitRate | num }}</span
                  >
                  <i
                    style="color: #FA5D22;"
                    class="el-icon-top"
                    v-if="item.profitRateAdd > 0"
                  ></i
                  ><i
                    v-if="item.profitRateAdd < 0"
                    style="color:#3ABA94"
                    class="el-icon-bottom"
                  ></i>
                </p>

                <span
                  :style="{
                    color: item.profitRateAdd >= 0 ? '#FA5D22' : '#3ABA94',
                    fontSize: '12px',
                  }"
                  >{{ item.profitRateAdd | num }}</span
                >
              </div>
            </div>
          </div> -->

          <!-- 最优合作方 -->
          <div v-show="active1 == '2'">
            <div
              class="weekList"
              v-for="(item, index) in RankingList.BestInvestor"
              :key="index"
              @click="pushDetail_(item.id)"
            >
              <div class="left" style="display: flex;flex: 1;">
                <div class="no">
                  <img
                    :src="
                      require('../../assets/images/crm/no' +
                        (index + 1) +
                        '.png')
                    "
                    alt=""
                  />
                </div>
                <div style="text-align: center;">
                  <p
                    style="width: 90px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
                  >
                    {{ item.simpleName }}
                  </p>
                </div>
              </div>
              <div style="flex:0.5;text-align: center;font-size: 14px;">
                账户数量
                <p>{{ item.accCount }}</p>
              </div>

              <div style="flex: 1;text-align: right;">
                <p style="white-space: nowrap;">
                  累计收益：
                  <span
                    :style="{
                      color: item.sumProfit >= 0 ? '#FA5D22' : '#3ABA94',
                      fontSize: '20px',
                    }"
                  >
                    {{ item.sumProfit | num }}</span
                  >
                </p>
                <span>&nbsp;</span>
              </div>
            </div>
          </div>
          <div @click="seeStrategy" class="more">
            查看更多<i class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import hhead from './header/index';
import crmNav from '../../components/crmNav/index';
import './style.css';
export default {
  components: { hhead, crmNav },
  data() {
    return {
      res: '',
      id: '',
      n_active: '1', //排行
      active: '1', //净值 回撤
      active1: '2', //策略 合作方
      RankingList: '',
      news: '', //消息
      jurisdiction: [], //权限
    };
  },
  mounted() {
    this.Ranking();

    this.$axios
      .post('/crm/mem/queryAllModel', {
        apiToken: this.$store.state.usermsg.apiToken,
        customerId: this.$store.state.usermsg.id,
      })
      .then((res) => {
        // console.log(res);
        if (res.data.code == 200) {
          this.jurisdiction = res.data.data.model;
        }
      });

    // 获取消息接口
    this.$axios
      .post('/crm/queryMessage', {
        apiToken: this.$store.state.usermsg.apiToken,
        size: 4,
      })
      .then((res) => {
        // console.log(res);
        if (res.data.code == 200) {
          this.news = res.data.data;
        }
      });

    this.$axios
      .post('/crm/ent/getAuthInfo', {
        apiToken: this.$store.state.usermsg.apiToken,
      })
      .then((res) => {
        // console.log(res);
        this.tokenInvalid(res);
        if (res.data.code == 200 || res.data.code == 403) {
          this.res = res.data.data;
        } else if (res.data.code == 400) {
          this.$router.push('/crm/qyQuery');
        } else if (res.data.code == 401) {
          this.$router.push('/crm/qyQuery/state');
        }
      });
  },
  filters: {
    //时间戳转换
    formatDate: function(value) {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? '0' + MM : MM;
      let d = date.getDate();
      d = d < 10 ? '0' + d : d;
      let h = date.getHours();
      h = h < 10 ? '0' + h : h;
      let m = date.getMinutes();
      m = m < 10 ? '0' + m : m;
      let s = date.getSeconds();
      s = s < 10 ? '0' + s : s;
      return y + '-' + MM + '-' + d;
    },
    //2020-12-11T05:27:56.370+0000转换
    renderTime: function(date) {
      if (date) {
        var dateee = new Date(date).toJSON();
        return new Date(+new Date(dateee) + 8 * 3600 * 1000)
          .toISOString()
          .replace(/T/g, ' ')
          .replace(/\.[\d]{3}Z/, '')
          .substr(0, 11);
      }
    },
    //审核失败原因
    each: function(list) {
      var text = '';
      if (list) {
        list.forEach((item) => {
          if (item) {
            text += item + ',';
          }
        });
        return text;
      }
    },
    //营业执照号处理
    code: function(code) {
      if (code) {
        return code.substr(0, 3) + '******' + code.substr(14, 4);
      }
    },
    //收益格式化
    num: function(n) {
      if (n) {
        return (Math.round(n * 10000) / 100).toFixed(2) + '%';
      } else {
        return '0.00%';
      }
    },
    num1: function(n) {
      if (n) {
        return Math.round(n * 10000) / 100;
      } else {
        return 0;
      }
    },
    //净值
    num2: function(n) {
      if (n) {
        return n.toFixed(4);
      } else {
        return 0;
      }
    },
    num3: function(n) {
      if (n) {
        return (Math.round(n * 10000) / 100).toFixed(2);
      } else {
        return 0;
      }
    },
  },
  methods: {
    pushDetail(id, serverId) {
      //查看详情
      // console.log(this.jurisdiction[4].selected);
      if (this.jurisdiction[4].selected) {
        //账户管理权限为true

        this.$router.push(`/crm/user/uDetails?id=${id}&serverId=${serverId}`);
      } else {
        this.$alert('当前用户暂无权限', {
          confirmButtonText: '确定',
          type: 'error',
          center: true,
        })
          .then(() => {})
          .catch(() => {});
      }
    },
    pushMechanism(){//注册信息
        // this.$router.push('/crm/mechanism')
    }, 
    pushDetail_(id) {
      //投顾详情
      if (this.jurisdiction[2].selected) {
        //投顾管理权限为true

        this.$router.push(`/crm/InvestorManage/details?id=${id}`);
      } else {
        this.$alert('当前用户暂无权限', {
          confirmButtonText: '确定',
          type: 'error',
          center: true,
        })
          .then(() => {})
          .catch(() => {});
      }
    },
    seeDate() {
      //查看更多 月 年排行
      this.$router.push(
        `/crm/Ranking?type=${this.n_active == '1' ? 'month' : 'year'}`
      );
    },
    seeNetWorth() {
      //查看更多 净值 回撤
      this.$router.push(
        `/crm/Ranking?type=${this.active == '1' ? 'netWorth' : 'hc'}`
      );
    },
    seeStrategy() {
      //查看更多 最优策略 合作方
      this.$router.push(
        `/crm/Ranking?type=${this.active1 == '1' ? 'strategy' : 'mechanism'}`
      );
    },
    pushNews() {
      this.$router.push('/crm/news');
    },
    Ranking() {
      //排行数据
      this.$axios
        .post('/crm/ent/getLeaderboard', {
          apiToken: this.$store.state.usermsg.apiToken,
          size: 5,
        })
        .then((res) => {
          //   console.log(res);
          if (res.data.code == 200) {
            this.RankingList = res.data.data;
          }
        });
    },
    cl() {
      //最优策略
      this.active1 = '1';
    },
    jg() {
      //最优合作方
      this.active1 = '2';
    },
    jz() {
      //净值排行
      this.active = '1';
    },
    hc() {
      //回撤排行
      this.active = '2';
    },
    year() {
      //本周排行
      this.n_active = '2';
    },
    month() {
      //本月排行
      this.n_active = '1';
    },
    edit() {
      //修改资料
      this.$store.state.reMsg.bizArea = this.res.bizArea;
      this.$store.state.reMsg.bizDirection = this.res.bizDirection;
      this.$store.state.reMsg.bizStrategy = this.res.bizStrategy;
      this.$store.state.reMsg.initMoney = this.res.initMoney;
      this.$store.state.reMsg.name = this.res.name;
      this.$store.state.reMsg.applyDoc = this.res.applyDoc;
      this.$store.state.reMsg.codePic = this.res.codePic;
      this.$store.state.reMsg.abbrName = this.res.abbrName;
      this.$store.state.reMsg.code = this.res.code;
      this.$store.state.reMsg.createDate = this.res.createDate;

      this.$router.push(`/crm/authentication_t?type=edit&id=${this.res.id}`);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/view/crm/index.vue